import {useCallback} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandSecretClientIcon, CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {useSemanticSearchHasConversationHydration} from "../hooks/use_semantic_search_local_storage";
import {closeSemanticSearchModal, expandSemanticSearchToFullscreen} from "../state/semantic_search_modal_slice";
import {getSemanticSearchModalSize} from "../tracking/get_semantic_search_modal_size";
import {hitAiAssistant} from "../tracking/semantic_search_gtm_events";
import {trackAmplitudeCloseAiChat} from "../tracking/track_amplitude_close_ai_chat";
import {SemanticSearchView} from "../view/SemanticSearchView";
import {SemanticSearchAuthOverlay} from "./semantic_search_auth/SemanticSearchAuthOverlay";
import {SemanticSearchQuery} from "./semantic_search_query/SemanticSearchQuery";
import {SemanticSearchBetaBadge} from "./SemanticSearchBetaBadge";
import {SemanticSearchFullscreenOverlay} from "./SemanticSearchFullscreenOverlay";

export const SemanticSearchModal = () => {
    const dispatch = useAppDispatch();
    const surfacePhase = useAppSelector((state) => state.semanticSearchModal.surfacePhase);
    const isSemanticSearchModalOpen = surfacePhase === "fullscreen";
    const {isMobile} = useUserDevice();

    useSemanticSearchHasConversationHydration();

    const onClose = useCallback(() => {
        const modalSize = getSemanticSearchModalSize(surfacePhase);

        if (modalSize) {
            trackAmplitudeCloseAiChat(modalSize, getAnalyticsSessionId());
        }

        hitAiAssistant("close");
        dispatch(closeSemanticSearchModal());
    }, [dispatch, surfacePhase]);

    const handleHalfSheetSubmit = useCallback(() => {
        dispatch(expandSemanticSearchToFullscreen());
    }, [dispatch]);

    return (
        <>
            <SemanticSearchFullscreenOverlay
                phase={surfacePhase}
                onClose={onClose}
                halfSheetChildren={
                    <div className={halfSheetContent}>
                        <div className={headerStyle}>
                            <BrandSecretClientIcon size="5.6" wrapperSize="5.6" wrapperColor="transparent" />
                            <Text variant="headline_6" as="p" align="left">
                                Opisz, czego szukasz. Dopasuję dla Ciebie najlepsze oferty
                            </Text>
                        </div>

                        <SemanticSearchQuery hasStickySidebar={false} quickQuestionsLayout="column" onSubmit={handleHalfSheetSubmit} />
                    </div>
                }
            >
                {(overlayRef) => (
                    <>
                        <div className={mobileTopBar}>
                            <div className={mobileTopBarText}>
                                <Text variant="body_copy_2" as="span" color="var(--colors-secondary)">
                                    Asystent AI
                                </Text>

                                <SemanticSearchBetaBadge />
                            </div>
                            <button type="button" onClick={onClose} aria-label="Zamknij" className={mobileTopBarCloseButton}>
                                <CloseIcon size="2" fill="var(--colors-secondary)" />
                            </button>
                        </div>

                        <Button
                            iconRight={CloseIcon}
                            className={closeButtonDesktop}
                            type="button"
                            variant="outlined_secondary"
                            size="small"
                            onClick={onClose}
                            aria-label="Zamknij"
                        >
                            ZAMKNIJ
                        </Button>

                        <SemanticSearchView containerRef={overlayRef} quickQuestionsLayout={!isSemanticSearchModalOpen || isMobile ? "column" : "inline"} />
                    </>
                )}
            </SemanticSearchFullscreenOverlay>

            {isMobile && <SemanticSearchAuthOverlay usePortal />}
        </>
    );
};

const mobileTopBar = css({
    position: "sticky",
    top: 0,
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    pl: 1.5,
    height: "48px",
    background: "var(--colors-gray-100)",

    lg: {
        display: "none"
    }
});

const mobileTopBarText = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 1.5
});

const mobileTopBarCloseButton = css({
    position: "absolute",
    right: 0,
    top: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "48px",
    height: "48px",
    background: "var(--colors-gray-200)",
    cursor: "pointer"
});

const closeButtonDesktop = css({
    position: "fixed",
    top: 90,
    left: 120,
    zIndex: 1,
    display: "none",

    lg: {
        display: "inline-flex"
    }
});

const halfSheetContent = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    pt: 4,
    px: 1.5,
    pb: 3
});

const headerStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mb: 1.5
});
import {useCallback} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandSecretClientIcon, CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {useSemanticSearchHasConversationHydration} from "../hooks/use_semantic_search_local_storage";
import {closeSemanticSearchModal, expandSemanticSearchToFullscreen} from "../state/semantic_search_modal_slice";
import {getSemanticSearchModalSize} from "../tracking/get_semantic_search_modal_size";
import {hitAiAssistant} from "../tracking/semantic_search_gtm_events";
import {trackAmplitudeCloseAiChat} from "../tracking/track_amplitude_close_ai_chat";
import {SemanticSearchView} from "../view/SemanticSearchView";
import {SemanticSearchAuthOverlay} from "./semantic_search_auth/SemanticSearchAuthOverlay";
import {SemanticSearchQuery} from "./semantic_search_query/SemanticSearchQuery";
import {SemanticSearchBetaBadge} from "./SemanticSearchBetaBadge";
import {SemanticSearchFullscreenOverlay} from "./SemanticSearchFullscreenOverlay";

export const SemanticSearchModal = () => {
    const dispatch = useAppDispatch();
    const surfacePhase = useAppSelector((state) => state.semanticSearchModal.surfacePhase);
    const isSemanticSearchModalOpen = surfacePhase === "fullscreen";
    const {isMobile} = useUserDevice();

    useSemanticSearchHasConversationHydration();

    const onClose = useCallback(() => {
        const modalSize = getSemanticSearchModalSize(surfacePhase);

        if (modalSize) {
            trackAmplitudeCloseAiChat(modalSize, getAnalyticsSessionId());
        }

        hitAiAssistant("close");
        dispatch(closeSemanticSearchModal());
    }, [dispatch, surfacePhase]);

    const handleHalfSheetSubmit = useCallback(() => {
        dispatch(expandSemanticSearchToFullscreen());
    }, [dispatch]);

    return (
        <>
            <SemanticSearchFullscreenOverlay
                phase={surfacePhase}
                onClose={onClose}
                halfSheetChildren={
                    <div className={halfSheetContent}>
                        <div className={headerStyle}>
                            <BrandSecretClientIcon size="5.6" wrapperSize="5.6" wrapperColor="transparent" />
                            <Text variant="headline_6" as="p" align="left">
                                Opisz, czego szukasz. Dopasuję dla Ciebie najlepsze oferty
                            </Text>
                        </div>

                        <SemanticSearchQuery hasStickySidebar={false} quickQuestionsLayout="column" onSubmit={handleHalfSheetSubmit} />
                    </div>
                }
            >
                {(overlayRef) => (
                    <>
                        <div className={mobileTopBar}>
                            <div className={mobileTopBarText}>
                                <Text variant="body_copy_2" as="span" color="var(--colors-secondary)">
                                    Asystent AI
                                </Text>

                                <SemanticSearchBetaBadge />
                            </div>
                            <button type="button" onClick={onClose} aria-label="Zamknij" className={mobileTopBarCloseButton}>
                                <CloseIcon size="2" fill="var(--colors-secondary)" />
                            </button>
                        </div>

                        <Button
                            iconRight={CloseIcon}
                            className={closeButtonDesktop}
                            type="button"
                            variant="outlined_secondary"
                            size="small"
                            onClick={onClose}
                            aria-label="Zamknij"
                        >
                            ZAMKNIJ
                        </Button>

                        <SemanticSearchView containerRef={overlayRef} quickQuestionsLayout={!isSemanticSearchModalOpen || isMobile ? "column" : "inline"} />
                    </>
                )}
            </SemanticSearchFullscreenOverlay>

            {isMobile && <SemanticSearchAuthOverlay usePortal />}
        </>
    );
};

const mobileTopBar = css({
    position: "sticky",
    top: 0,
    zIndex: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    pl: 1.5,
    height: "48px",
    background: "var(--colors-gray-100)",

    lg: {
        display: "none"
    }
});

const mobileTopBarText = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 1.5
});

const mobileTopBarCloseButton = css({
    position: "absolute",
    right: 0,
    top: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "48px",
    height: "48px",
    background: "var(--colors-gray-200)",
    cursor: "pointer"
});

const closeButtonDesktop = css({
    position: "fixed",
    top: 90,
    left: 120,
    zIndex: 1,
    display: "none",

    lg: {
        display: "inline-flex"
    }
});

const halfSheetContent = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    pt: 4,
    px: 1.5,
    pb: 3
});

const headerStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mb: 1.5
});
